/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './labor-progression.reducer';

export const LaborProgressionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const laborProgressionEntity = useAppSelector(state => state.laborProgression.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="laborProgressionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.laborProgression.detail.title">LaborProgression</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.laborProgression.id">Id</Translate>
            </span>
          </dt>
          <dd>{laborProgressionEntity.id}</dd>
          <dt>
            <span id="observation">
              <Translate contentKey="tinyMedicRestApp.laborProgression.observation">Observation</Translate>
            </span>
          </dt>
          <dd>{laborProgressionEntity.observation}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.laborProgression.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{laborProgressionEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.laborProgression.active">Active</Translate>
            </span>
          </dt>
          <dd>{laborProgressionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.laborProgression.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{laborProgressionEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.laborProgression.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{laborProgressionEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.laborProgression.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{laborProgressionEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.laborProgression.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{laborProgressionEntity.timestampEntry}</dd>
          <dt>
            <span id="expose">
              <Translate contentKey="tinyMedicRestApp.laborProgression.expose">Expose</Translate>
            </span>
          </dt>
          <dd>{laborProgressionEntity.expose ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.laborProgression.obstetricEvent">Obstetric Event</Translate>
          </dt>
          <dd>{laborProgressionEntity.obstetricEvent ? laborProgressionEntity.obstetricEvent.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.laborProgression.incident">Incident</Translate>
          </dt>
          <dd>{laborProgressionEntity.incident ? laborProgressionEntity.incident.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.laborProgression.pregnancy">Pregnancy</Translate>
          </dt>
          <dd>{laborProgressionEntity.pregnancy ? laborProgressionEntity.pregnancy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.laborProgression.vital">Vital</Translate>
          </dt>
          <dd>{laborProgressionEntity.vital ? laborProgressionEntity.vital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/labor-progression" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/labor-progression/${laborProgressionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LaborProgressionDetail;
